import styled, { css } from 'styled-components';
import { Popout, PopoutWrapper, SvgHelperWrapper } from 'src/components';
import theme from 'src/utils/theme';

const navFontHeightRem = 1.5 * 1.25;
const headerDesktopHeight = theme.sz.s20;
const headerSpaceBelowNav = `calc((${headerDesktopHeight} - ${navFontHeightRem}rem) / 2)`;

export const DropdownSublist = styled(Popout.ParentContainer)(
  ({ theme }) => css`
    ${PopoutWrapper} {
      /* use non-theme shadow because all standard shadows overlap dropdown arrow */
      box-shadow: 0 3px 3px hsla(0, 0%, 0%, 0.14);
      background-color: ${theme.co.primary30};
      border-radius: ${theme.bo.mediumLarger};
      padding: ${theme.sz.s8} ${theme.sz.s6};
      margin-top: ${headerSpaceBelowNav};
    }
  `,
);

export const SublistButtonWrapper = styled.div(() => css``);

export const SublistButton = styled.button(
  ({ theme }) => css`
    background: none;
    color: inherit;
    padding: ${theme.sz.s0};
    border: none;
    cursor: pointer;
    transition: transform 0.5s ease;
    ${theme.typography.heading.desktop.xs};

    &:hover {
      transform: translateY(-${theme.sz.s05});
    }
  `,
);

export const DropdownArrow = styled(SvgHelperWrapper)(
  ({ theme }) => css`
    font-size: ${theme.sz.s6};
    color: ${theme.co.primary30};
    position: absolute;
    left: calc(50% - ${theme.sz.s6} / 2);
    bottom: calc(-1 * ${headerSpaceBelowNav} - ${theme.sz.s05});
  `,
);

export const DropdownContent = styled.div(
  ({ theme }) => css`
    display: flex;
    gap: ${theme.sz.s6};
  `,
);

export const Sublist = styled.ul(
  ({ theme }) => css`
    list-style-type: none;
    padding: ${theme.sz.s0};

    /* if there is only one column and it has only one link */
    &:first-of-type:last-of-type li:first-of-type:last-of-type {
      border-bottom: none;
      padding: ${theme.sz.s0};
      min-height: ${theme.sz.s12};
      width: unset;
      white-space: nowrap;
    }
  `,
);

export const SublistItem = styled.li(
  ({ theme }) => css`
    list-style-type: none;
    min-height: ${theme.sz.s16};
    padding: ${theme.sz.s2} ${theme.sz.s0};
    width: ${theme.sz.s54};
    max-width: ${theme.sz.s54};
    border-bottom: ${theme.bo.thinWidth} solid ${theme.co.secondary40};
  `,
);

export const SublistItemContent = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.sz.s1};
    min-height: ${theme.sz.s12};
  `,
);

export const SublistItemFlag = styled.div(
  ({ theme }) => css`
    flex-shrink: 0;
    display: flex;
    height: ${theme.sz.s10};
    width: ${theme.sz.s10};
    font-size: ${theme.sz.s10};
  `,
);

export const SublistLink = styled.a(
  ({ theme }) => css`
    display: inline-block;
    color: ${theme.co.neutral0};
    ${theme.typography.paragraph.base};
    text-decoration: none;
    transition: transform 0.5s ease;

    &:hover {
      transform: translateY(-${theme.sz.s05});
    }
  `,
);

export const DropdownOptions = styled(Popout)<{ $show: boolean }>(
  ({ $show }) => css`
    display: ${$show ? 'block' : 'none'};
  `,
);
